module.exports = __webpack_public_path__ + "static/media/world.e0c8e4d8.svg";